import { useEffect, useState } from "react"
import { createPortal } from "react-dom"

// Slots rendered by navbar.js. A page can inject its title/greeting into the
// left slot and its controls (period filter, exports, …) into the right slot,
// without the navbar needing to know about them.
export const TOPBAR_SLOT_ID = "topbar-actions-slot"
export const TOPBAR_TITLE_SLOT_ID = "topbar-title-slot"

export const TopbarPortal = ({ children, slot = TOPBAR_SLOT_ID }) => {
  const [el, setEl] = useState(null)

  // The slot lives in the navbar, which can commit to the DOM after the page
  // does (route transitions, slow devices). Retry on animation frames until
  // the slot exists instead of silently rendering nothing.
  useEffect(() => {
    let raf
    const find = () => {
      const node = document.getElementById(slot)
      if (node) setEl(node)
      else raf = requestAnimationFrame(find)
    }
    find()
    return () => cancelAnimationFrame(raf)
  }, [slot])

  return el ? createPortal(children, el) : null
}

export default TopbarPortal
